export default __webpack_public_path__ + "static/media/Icon awesome-chart-bar.60d0649c.svg";